// @flow
// GA4 식별자 캡처
// 체크아웃 시 브라우저의 GA4 _ga / _ga_<stream> 쿠키에서 client_id / session_id를 읽어
// 주문 doc(doc.analytics)에 저장한다. 서버사이드(Event Bus)에서 GA4 Measurement Protocol로
// purchase/refund를 전송할 때 이 값들로 웹 세션·광고 클릭과 전환을 결합한다.

const readCookie = (name: string): string => {
  if (typeof document === 'undefined' || !document.cookie) return '';
  const prefix = `${name}=`;
  const hit = document.cookie.split('; ').find(part => part.indexOf(prefix) === 0);
  return hit ? decodeURIComponent(hit.slice(prefix.length)) : '';
};

// _ga 쿠키: "GA1.1.1234567890.1700000000" → client_id "1234567890.1700000000"
const parseClientId = (): string => {
  const raw = readCookie('_ga');
  if (!raw) return '';
  // 앞쪽 "GA1.<n>." 접두를 제거하고 나머지(part1.part2)를 client_id로 사용
  const parts = raw.split('.');
  if (parts.length < 4) return '';
  return `${parts[2]}.${parts[3]}`;
};

// _ga_<STREAM> 쿠키: "GS1.1.<session_id>.<...>" → session_id
// STREAM 접미는 측정 ID에서 'G-' 를 뗀 값 (예: G-ABC123 → _ga_ABC123)
const parseSessionId = (): string => {
  const measurementId = process.env.REACT_APP_GA4_MEASUREMENT_ID || '';
  const stream = measurementId.replace(/^G-/, '');
  if (!stream) return ''; // 측정 ID 미설정 시 session_id는 생략(클라이언트 id만으로도 집계 가능)
  const raw = readCookie(`_ga_${stream}`);
  if (!raw) return '';
  const parts = raw.split('.');
  // GS1.1.<session_id>.<session_count>...
  return parts.length >= 3 ? parts[2] : '';
};

export const getGa4Identity = (): {
  ga_client_id: string,
  ga_session_id: string,
  captured_at: string,
} => {
  try {
    return {
      ga_client_id: parseClientId(),
      ga_session_id: parseSessionId(),
      captured_at: new Date().toISOString(),
    };
  } catch (e) {
    return { ga_client_id: '', ga_session_id: '', captured_at: new Date().toISOString() };
  }
};

export default getGa4Identity;



// WEBPACK FOOTER //
// ./src/lib/tracking/ga4Identity.js